"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.NftValueTypeHandler = void 0;
exports.isNftValueType = isNftValueType;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _bignumber = _interopRequireDefault(require("bignumber.js"));
var _variable = require("../variable");
function isNftValueType(val) {
  return (val === null || val === void 0 ? void 0 : val.type) === "nft";
}
class NftValueTypeHandler {
  constructor() {
    (0, _defineProperty2.default)(this, "type", "nft");
  }
  value(val) {
    return val.value;
  }
  truthy(val) {
    var _val$value;
    return !!((_val$value = val.value) !== null && _val$value !== void 0 && _val$value.tokenId);
  }
  stringValue(value) {
    var _value$value;
    return value === null || value === void 0 ? void 0 : (_value$value = value.value) === null || _value$value === void 0 ? void 0 : _value$value.tokenId;
  }
  numeric(value) {
    var _value$value2;
    let bn = new _bignumber.default((_value$value2 = value.value) === null || _value$value2 === void 0 ? void 0 : _value$value2.tokenId);
    if (bn.isNaN()) {
      return null;
    }
    return bn;
  }
  readPath(val, path) {
    return (0, _variable.readReferencePath)(val.value, path);
  }
}
exports.NftValueTypeHandler = NftValueTypeHandler;
//# sourceMappingURL=NftValueTypeHandler.js.map